import { useState } from "react";
import { Modal, Button, Field } from "./ui";
import { FileIcon } from "./ui/Icons";

export default function AddFileModal({ onClose, onSave }) {
  const [fileName, setFileName] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    if (!fileName.trim()) {
      setError("Give the file a name so you can find it later.");
      return;
    }
    setSaving(true);
    await onSave({ fileName: fileName.trim() });
    setSaving(false);
  };

  return (
    <Modal
      onClose={onClose}
      icon={FileIcon}
      title="Create a new file"
      description="A file groups everything you import into one Naqood organisation."
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSave} loading={saving}>
            Create file
          </Button>
        </>
      }
    >
      <Field
        label="File name"
        required
        error={error}
        hint="For example: Raqi AI — FY2025"
      >
        <input
          autoFocus
          className="field-input"
          placeholder="Enter a file name"
          value={fileName}
          onChange={(e) => {
            setFileName(e.target.value);
            setError("");
          }}
          onKeyDown={(e) => e.key === "Enter" && handleSave()}
        />
      </Field>
    </Modal>
  );
}
